import React from 'react';
// https://www.npmjs.com/package/react-youtube
import YouTube from 'react-youtube';
import BaseComponent from './BaseComponent';
import ProjectView from './ProjectView';
import { MediaStatusTypes } from '../../Constants';
import Styles from './Media.cssmodule.less';
import axios from 'axios';
import _includes from 'lodash/includes';

class Media extends BaseComponent {
    getOption() {
        let option = {
            width: '580',
            height: '327',
            playerVars: {
                modestbranding: 1,
                rel: 0,
                showinfo: 0,
            },
        };
        if (this.props.option) {
            option = Object.assign({}, option, this.props.option);
        }

        return option;
    }

    state = {
        videoUrl: '',
    };

    componentDidMount() {
        const { media = {} } = this.props;
        const { category = '', content = '' } = media;

        if (this.blockWrapper) {
            if (category === MediaStatusTypes.BLOCK) {
                const wrapper = Entry.createElement('div');
                $(this.blockWrapper).empty().append(wrapper);
                this.blockRenderView = new Entry.RenderView(
                    wrapper,
                    'LEFT_MOST'
                );
                this.setBlockRenderView(content);
            }
        }

        if (category === MediaStatusTypes.VIDEO) {
            this.getVideoUri(content);
        }
    }

    componentDidUpdate(prevProps) {
        const { media = {} } = this.props;
        const { category = '', content = '' } = media;
        const { media: prevMedia = {} } = prevProps;
        const { content: prevContent = '' } = prevMedia;

        if (category === MediaStatusTypes.BLOCK) {
            const wrapper = Entry.createElement('div');
            $(this.blockWrapper).empty().append(wrapper);
            this.blockRenderView = new Entry.RenderView(wrapper, 'LEFT_MOST');

            this.setBlockRenderView(content);
        }

        if (category === MediaStatusTypes.VIDEO && prevContent !== content) {
            this.getVideoUri(content);
        }
    }

    componentWillUnmount() {
        $(this.blockRenderView).empty();
    }

    setBlockRenderView(content) {
        let code = [];
        if (content) {
            code = JSON.parse(content);
        }

        this.blockRenderView.changeCode(new Entry.Code(code), true);
    }

    getVideoUriByNaver(content) {
        const clipNo = this.getClipNoByNaver(content);
        if (clipNo) {
            axios
                .get(
                    `https://api.tv.naver.com/api/open/share/clip.json?clipNo=${clipNo}`
                )
                .then((response) => {
                    const content = response.data.content;
                    if (!content) {
                        return this.setState({ videoUrl: content });
                    }
                    const { videoId = '', outKey = '' } = content;
                    this.setState({
                        videoUrl: `//serviceapi.rmcnmv.naver.com/flash/outKeyPlayer.nhn?vid=${videoId}&outKey=${outKey}&controlBarMovable=true&jsCallable=true&isAutoPlay=true&skinName=tvcast_white`,
                    });
                });
        }
    }

    getVideoUri(content) {
        if (_includes(content, 'youtube')) {
            return this.setState({
                videoUrl:
                    '//www.youtube.com/embed/' +
                    this.getVideoIdByYouTube(content) +
                    '?rel=0',
            });
        }

        if (_includes(content, 'tv.naver')) {
            return this.getVideoUriByNaver(content);
        }

        return this.setState({ videoUrl: content });
    }

    createProjectView() {
        const { media = {}, checkScript, params } = this.props;
        const { guide, content } = media;
        const { title, message } = guide || {};
        return (
            <span className={guide ? Styles.hasGuideProject : ''}>
                <ProjectView
                    content={content}
                    checkScript={checkScript}
                    params={params}
                >
                    {this.getLang('Workspace.project')}
                    {content}
                </ProjectView>
                {guide && (
                    <div className={Styles.guideBox}>
                        <div className={Styles.title}>{title}</div>
                        <div className={Styles.message}>{message}</div>
                    </div>
                )}
            </span>
        );
    }

    createProjectElementView() {
        const { media = {} } = this.props;
        const { guide, content } = media;
        const { title, message } = guide || {};
        if (guide) {
            return (
                <span className={guide ? Styles.hasGuideProjectElement : ''}>
                    {this.createProjectOnlyView(content)}
                    {guide && (
                        <div className={Styles.guideBox}>
                            <div className={Styles.title}>{title}</div>
                            <div className={Styles.message}>{message}</div>
                        </div>
                    )}
                </span>
            );
        }
        return this.createProjectOnlyView(content);
    }

    createProjectOnlyView(content) {
        return (
            <div
                className={`${this.Styles.projectElement} ${Styles.projectElement}`}
                ref={(dom) => {
                    if (dom) {
                        if (dom.firstChild) {
                            dom.removeChild(dom.firstChild);
                        }
                        dom.appendChild(content);
                        if (Entry.windowResized) {
                            Entry.windowResized.notify();
                        }
                    }
                }}
            />
        );
    }

    createMedia() {
        const { checkScript, media, params } = this.props;
        const { category, content } = media;
        let mediaComp;
        switch (category) {
            case MediaStatusTypes.IMAGE: {
                mediaComp = <img alt="media" src={content} />;
                break;
            }
            case MediaStatusTypes.BLOCK: {
                mediaComp = (
                    <div
                        ref={(dom) => {
                            this.blockWrapper = dom;
                        }}
                    />
                );
                break;
            }
            case MediaStatusTypes.VIDEO: {
                //<youtube> 동작 안함, <object>코드 사용시 링크만 바뀐 경우 동작 안함
                mediaComp = (
                    <iframe
                        width="100%"
                        height="100%"
                        src={this.state.videoUrl}
                        frameBorder="0"
                        allowFullScreen
                    />
                );
                break;
            }
            case MediaStatusTypes.EDWITH: {
                const { postId } = JSON.parse(content);
                mediaComp = (
                    <iframe
                        width="100%"
                        height="100%"
                        src={`/player/${postId}`}
                        frameBorder="0"
                        allowFullScreen
                    />
                );
                break;
            }
            case MediaStatusTypes.PROJECT:
            case MediaStatusTypes.LECTURE_PROJECT: {
                mediaComp = this.createProjectView();
                break;
            }
            case MediaStatusTypes.PROJECT_ELEMENT:
            case MediaStatusTypes.LECTURE_PROJECT_ELEMENT: {
                mediaComp = this.createProjectElementView();
                break;
            }
            case MediaStatusTypes.ELEMENT: {
                mediaComp = (
                    <div
                        className={`${this.Styles.element}`}
                        ref={(dom) => {
                            if (dom) {
                                if (dom.firstChild) {
                                    dom.removeChild(dom.firstChild);
                                }
                                dom.appendChild(content);
                            }
                        }}
                    />
                );
                break;
            }
            default: {
                mediaComp = null;
                break;
            }
        }

        return mediaComp;
    }

    render() {
        const { media = {} } = this.props;
        const { category } = media;
        const wrapperStyle = {};

        if (category === MediaStatusTypes.IMAGE) {
            wrapperStyle.overflow = 'hidden';
            wrapperStyle.justifyContent = 'center';
        }

        return (
            <div
                className={`${this.props.className || 'quizBody-media'} ${
                    Styles.media
                }`}
                style={wrapperStyle}
            >
                {this.props.media && this.createMedia()}
            </div>
        );
    }
}

Media.displayName = 'Media';
Media.propTypes = {
    // media: PropTypes.object.isRequired,
};

export default Media;



// WEBPACK FOOTER //
// ./components/CommonSet/Media.js